import { Stack } from "@mui/material";

import { Button } from "../../components/Button";
import { Text } from "../../components/Text";
import { formatChargeDifferentialPercent } from "../constants";

interface LeadTimeDifferentialRowProps {
  thresholdInHours: number;
  incrementalMultiplier: number;
  isDeleting: boolean;
  onDeleteClick: () => void;
}

export function LeadTimeDifferentialRow(props: LeadTimeDifferentialRowProps) {
  const { thresholdInHours, incrementalMultiplier, isDeleting, onDeleteClick } = props;

  return (
    <Stack
      direction="row"
      spacing={3}
      sx={(theme) => ({
        alignItems: "center",
        justifyContent: "space-between",
        paddingY: 2,
        borderBottom: `1px solid ${theme.palette.border?.base ?? theme.palette.divider}`,
        "&:last-of-type": { borderBottom: "none" },
      })}
    >
      <Text variant="body2">
        Within {thresholdInHours} {thresholdInHours === 1 ? "hr" : "hrs"} of start
      </Text>
      <Text semibold variant="body2">
        {formatChargeDifferentialPercent(incrementalMultiplier)}
      </Text>
      <Button disabled={isDeleting} size="small" variant="outlined" onClick={onDeleteClick}>
        Delete
      </Button>
    </Stack>
  );
}
